<template>
  <v-card-text class="d-flex justify-space-between">
    <div class="mt10"></div>
    <v-simple-table class="w-100">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ERROS</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-left" v-for="(errorsItem, index) of errorsJson" :key="index">
            <td class="pt-5">
              <p>
                {{ errorsItem }}
              </p>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card-text>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ConfirmationStep',
  props: {
    errorsJson: {
      type: Array,
      default: () => []
    }
  },

  async mounted() {},

  watch: {},
  computed: {
    parameterID() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions('ImportManualDashboardStore', [
      'fetchQuantitiesNfesAndDeliveriesByCity',
      'fetchQuantitiesNfesAndDeliveriesBySender'
    ])
  }
};
</script>
<style lang="scss" scoped></style>
